<template>
   <div>
      <div class="row p-2 mt-4">
         <div class="col-12">
            <span class="custom-span-lg" style="color: #435666;">Admin Settings
               <i class="fa-solid fa-arrow-right"></i>
            </span>
            <span class="custom-span-no-weight" style="color: #435666;"> &nbsp;Password Websites</span>
            <div class="mt-2">
               <small class="text-muted">
                  <i class="fa-solid fa-key me-1" style="color: #00A0C1;"></i>
                  Manage websites that contain password or login pages.
               </small>
            </div>
         </div>
      </div>

      <PasswordWebsites />
   </div>
</template>

<script>
import PasswordWebsites from '@/components/Admin Controls/PasswordWebsites.vue';

export default {
   components: { PasswordWebsites },
}
</script>

<style scoped>
.custom-span-lg { font-size: 24px; line-height: 24px; font-weight: bold; }
.custom-span-no-weight { font-size: 24px; line-height: 24px; font-weight: 250; }
</style>